import styled from "styled-components";

export const Container = styled.div`
  width: 30rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  background: #ffffff;
  border-radius: 3px;
`;

export const Title = styled.span`
  padding-top: 1.45rem;

  font-family: "Sora";
  font-style: normal;
  font-weight: 600;
  font-size: 0.86rem;
  line-height: 1.1rem;

  color: #212326;
`;

export const SubTitle = styled.span`
  padding-top: 0.43rem;

  font-family: "Sora";
  font-style: normal;
  font-weight: 400;
  font-size: 0.67rem;
  line-height: 0.86rem;

  color: #7e858f;
`;

export const Footer = styled.div`
  width: 17.81rem;
  display: flex;
  justify-content: space-between;

  button {
    width: 8.62rem;
    height: 2rem;
    margin: 2.5rem 0rem 2.15rem 0rem;
  }
`;
